import { useLocation, useParams } from 'react-router-dom';

import { IPromoCodesFormParams } from 'features/PromoCodesForm/types';
import { PromoCodesForm as GreenPromoCodesForm } from 'features/PunchupPages/PromoCodesForm';
import { PromoCodesForm as LegacyPromoCodesForm } from 'features/Punchup/PromoCodesForm';
import { sendGAPage } from 'utils/utils';
import { useAppSelector } from 'store/hooks';
import { useEffect } from 'react';

const EventPromoCodeFormPage: React.FC = () => {
	const { pathname } = useLocation();
	const { type } = useParams<IPromoCodesFormParams>();
	const { isPunchup, greenZoneEnabled } = useAppSelector((state) => state.auth);

	useEffect(() => {
		sendGAPage({ page: pathname, title: `Event Promo Codes ${type}` });
	}, []);

	// Two-branch (PoolsPage pattern): green form only behind the green-zone gate; everything else
	// (greenZone-OFF punchup + standalone) keeps develop's legacy Punchup promo form verbatim.
	if (isPunchup && greenZoneEnabled) return <GreenPromoCodesForm />;
	return <LegacyPromoCodesForm />;
};

export default EventPromoCodeFormPage;
